<div class="main-container p-0 mt-0 mt-md-5 p-md-5 m-md-auto" [attr.dir]="isRTL() ? 'rtl' : 'ltr'">
    <div class="d-none d-md-block w-100 text-center">
        <h1 class="title">{{ "interviewUi.title" | translate }}</h1>
        <p class="description">{{ "interviewUi.tryFirstAttempt" | translate }}</p>
        <div class="card">
            <img src="../../../../../assets/icon/roket.svg" alt="roket icon"
                [style.left.%]="!isRTL() ? progressValueCurrentValue : null"
                [style.right.%]="isRTL() ? progressValueCurrentValue : null" class="rocket">
            <p-progressBar [value]="progressValueCurrentValue" [showValue]="false"></p-progressBar>
        </div>
    </div>

    <!-- Loading State -->
    <div class="video-container container" *ngIf="isLoadingQuestions">
        <div class="row h-100 justify-content-center align-items-center">
            <div class="col-12 text-center">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">{{ "Loading..." | translate }}</span>
                </div>
                <p class="mt-3">{{ "interviewUi.loadingQuestions" | translate }}</p>
            </div>
        </div>
    </div>

    <!-- Interview Content -->
    <div class="video-container container" *ngIf="!isLoadingQuestions">
        <div class="row h-100" *ngIf="!isStartVr">
            <div class="col-md-6 order-md-1 order-2 col-12 video-check p-md-5 p-0 text-center">
                <p class="d-none d-md-block">{{ "interviewUi.checkCameraMic" | translate }}</p>
                <div class="record-container my-4">
                    <video #previewVideo id="preview" muted autoplay></video>
                </div>
                <div class="btns">
                    <div class="btn-media">
                        <button class="media" (click)="toggleCamera()">
                            <i class="bi media-icons"
                                [ngClass]="isVideoOn ? 'bi-camera-video-fill' : 'bi-camera-video-off'"></i>
                        </button>
                        <button class="media" (click)="toggleMic()">
                            <i class="bi media-icons" [ngClass]="isMicOn ? 'bi-mic' : 'bi-mic-mute'"></i>
                        </button>
                    </div>

                    <button class="record-button d-block mb-4 my-md-0" (click)="startInterview()">
                        {{ "interviewUi.start" | translate }}
                    </button>
                </div>
            </div>

            <div class="col-md-6 ai order-md-2 order-1 col-12 p-0">
                <div class="image-video">
                    <div class="back-btn d-block d-md-none">
                        <i class="bi" [ngClass]="isRTL() ? 'bi-chevron-right' : 'bi-chevron-left'"></i>
                        <a href="./virtualInterviewSteps">
                            {{ "Back" | translate }}
                        </a>
                    </div>
                    <div>
                        <img src="../../../../../assets/img/floating-robot.png" alt="robot">
                        <p>{{ "interviewUi.aiTrainee" | translate }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="ques-row h-100" *ngIf="isStartVr">
            <app-interview-question [question]="questions[currentQuestionIndex]" [sessionId]="sessionId"
                [isLastQuestion]="currentQuestionIndex === questions.length - 1" (next)="handleNextQuestion($event)"
                [currentQuestionComments]="currentQuestionComments" [commentsRemaining]="commentsRemaining"
                [isCommentRecording]="isCommentRecording" [commentTimeRemaining]="commentTimeRemaining"
                (startComment)="startCommentRecording()" (stopComment)="stopCommentRecording()"
                (commentAdded)="onCommentAdded()" (cancelComment)="cancelCommentRecording()" [language]="language">
            </app-interview-question>
        </div>
    </div>

    <div class="comment-tips d-none d-md-block" *ngIf="showTips && isStartVr" [attr.dir]="isRTL() ? 'rtl' : 'ltr'">
        <span class="close-icon" (click)="showTips = false">&times;</span>
        <h6>{{ "interviewUi.quickTips" | translate }}</h6>
        <ul>
            <li>{{ "interviewUi.tip1" | translate }}</li>
            <li>{{ "interviewUi.tip2" | translate }}</li>
            <li>{{ "interviewUi.tip3" | translate }}</li>
        </ul>
    </div>
</div>